import { StyleSheet } from "react-native";
import { appColors, appFonts, fontSize } from '../../appTheme';

export const viewProductDetailsStyle = StyleSheet.create({
    containerView: {
        flex: 1,
    },
    searchView: {
        marginHorizontal: 7,
        marginTop: 10
    },
    buttonContainerStyle: {
        marginHorizontal: 5,
        marginTop: 18
    },
    buttonTitleStyle: {
        fontSize: fontSize.mediumFontSize,
        fontFamily: appFonts.bold
    },
    iconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 6,
        borderColor: appColors.lightGrey,
        marginHorizontal: 5
    },
    iconTextStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.smallHeaderFontSize
    },
    iconStyle: {
        color: appColors.grey,
        paddingRight: 5
    },
    badgeStyle: {
        backgroundColor: '#ffedbd',
        width: 90,
        height: 25
    },
    textStyle: {
        fontFamily: appFonts.bold,
        fontSize: fontSize.badgeFontSize,
        color: appColors.lightDark,
    },
    iconBorderStyle: {
        borderWidth: 1,
        borderRadius: 11,
        width: 40,
        height: 40,
        margin: 3,
        padding: 3,
        borderColor: appColors.light,
        backgroundColor: appColors.lightBackgroundColor
    },
    headerSection: {
        flexDirection: 'row', justifyContent: 'space-between'
    },
    contentSection: {
        flexDirection: 'row', flex: 1
    },
    filterContainer: { marginVertical: 10, marginHorizontal: 15, borderRadius: 16 },
    filterHeaderStyle: { flexDirection: 'row', marginVertical: 5, justifyContent: 'flex-end' },
    filterFooterStyle: {
        flexDirection: 'row', marginVertical: 5, marginHorizontal: 10, justifyContent: "space-between", alignSelf: 'flex-end'
    },
    buttonStyle: { width: 100, height: 40, borderRadius: 7, backgroundColor: appColors.light, borderWidth: 1, borderColor: appColors.primary, },
    dashBoardConatiner: { marginVertical: 10, marginHorizontal: 17, },
    dashBoardView: { padding: 10, justifyContent: 'center', alignItems: 'center', flex: 0.5, marginHorizontal: 5, borderRadius: 8 },
    plusStyle: { position: "absolute", backgroundColor: appColors.primary, width: 60, height: 60, borderRadius: 32, top: '90%', left: '80%', justifyContent: 'center' },
    listContainer: {
        flex: 1,
        borderRadius: 8,
        marginHorizontal: 20,
        marginVertical: 10,
        padding: 20,
        backgroundColor: appColors.light
    },
    badgeContainerStyle: {
        justifyContent: 'center',
        alignSelf: 'flex-start',
    },
    titleStyle: { color: appColors.primary, fontFamily: appFonts.bold, fontSize: fontSize.mediumFontSize },

})